import React from 'react'
import { PieChart } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { styled } from '@mui/material/styles';
import { useStateContext } from '../../../context/ContextProvider';

  const size = {
    width: 400,
    height: 100,
  };
  
  const StyledText = styled('text')(({ theme }) => ({
    fill: theme.palette.text.primary,
    textAnchor: 'middle',
    dominantBaseline: 'central',
    fontSize: 20,
  }));
  
  function PieCenterLabel({ children }) {
    const { width, height, left, top } = useDrawingArea();
    return (
      <StyledText x={left + width / 2} y={top + height / 2}>
        {children}
      </StyledText>
    );
  }

function Chart({Data}) {
    const {currentMode}=useStateContext()
    const secondColer = currentMode === "Light" ? "#ffffff" :"#0A0924"
    const data = [
        { value: Data.value, label: Data.label, color: Data.color },
        { value: Data.value2, label:  Data.label2,color: secondColer },
 
      ];
      
  return (

       <PieChart series={[{ data, innerRadius: 80  }]}     slotProps={{
    legend: { hidden: true },
  }} {...size}>
     
    </PieChart>

  
  )
}

export default Chart